<app-template [title]="conferenceStepItem?.structureitem?.title"
              [subTitle]="conferenceStepItem?.structureitem?.subtitle" [footerVisible]="true" [fullLayout]="true">
       <div [innerHTML]="colorService.svgList.arrow_left_circle_svg.htmlText" *ngIf="conferenceStepItem?.structureitem" class="action-back-header" (click)="backNavigation()"></div>
  <div class="search-container">
    <div class="search-area">
      <div class="search-button" [@hide]='hide' (click)="search()" *ngIf="disable">Pesquisar</div>
      <input [@rotatedState]='state' [(ngModel)]="textSearch" minlength="3" *ngIf="disable">
      <div class="search-img" (click)="showHide()">
        <div [innerHTML]="colorService.svgList[imageName].htmlText" class="search-svg"></div>
      </div>
    </div>
    <div class="{{classMsg}}" *ngIf="showMessage">
      <div class="message" [ngStyle]="{'background-color': wasFound ? '#316b31' : '#a83838'}">
        <strong>{{searchMessage}}</strong>
        <div class="close" (click)="closeMessage()">x</div>
      </div>
    </div>
  </div>
  <div class="conference-step-container" *ngIf="conferenceStepItem?.itens">
    <div class="card-item-empty" *ngIf="conferenceStepItem.itens.length === 0">
      Não existe nenhum {{conferenceStepItem?.structureitem?.name}} para ser exibido
    </div>
    <div class="cards-container">
      <div class="card-item"
           [ngClass]="{
        'clickable': conferenceStepItem?.structureitem?.hasNext,
        'checked': stepItem.checked
      }" *ngFor="let stepItem of conferenceStepItem?.itens" (click)="selectNextStep(stepItem)">
        <div class="item-image-container" [style.backgroundImage]="stepItem.image ? 'url(' + stepItem.image + ')': ''">
          <div class="card-item-content" [class.center-container]="!stepItem.description">
            <h4 [class.center]="!stepItem.description">{{stepItem.name}}</h4>
            <p>{{stepItem.description}}</p>
          </div>
          <div class="card-actions">
            <div class="check card-actions-item" [ngClass]="{'checked': stepItem.checked}"
                *ngIf="conferenceStepItem?.structureitem?.votes" (click)="checkItem(stepItem)">
              <div class="icon" *ngIf="!stepItem.checked"></div>
              <div [innerHTML]="colorService.svgList.check_circle_svg.htmlText" class="check-circle"  *ngIf="stepItem.checked"></div>
              Destacar
            </div>
            <div class="comment card-actions-item" [ngClass]="{'checked': stepItem.checked}"
                *ngIf="conferenceStepItem?.structureitem?.comments" (click)="comment(stepItem)">
              <div [innerHTML]="!stepItem.checked ?  colorService.svgList.comment2_svg.htmlText : colorService.svgList.comment2_white_svg.htmlText" class="comment-svg"></div>
              <div class="count" *ngIf="stepItem.comment || stepItem.commentsMade > 0">{{ stepItem.commentsMade || 1 }}
              </div>
              Inserir Proposta
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions-footer">
    <div [innerHTML]="colorService.svgList.arrow_left_circle_svg.htmlText" class="action-back" (click)="backNavigation()"></div>
    <div class="help-container" *ngIf="conferenceStepItem?.structureitem?.parentLink" (click)="openAlternativeProposal()">
      <span class="action-back">{{conferenceStepItem?.structureitem?.parentLink?.textLink}}</span>
      <div [innerHTML]="colorService.svgList.help_circle_svg.htmlText" class="action-back"></div>
    </div>
  </div>
  <app-modal class="modalComment" [show]="showModalComment" (onCallback)="modalOnCallback($event)">
    <h2>{{itemSelect?.name}}</h2>
    <p>{{itemSelect?.description}}</p>
    <textarea [maxlength]="280" rows="6" *ngIf="itemSelect" [(ngModel)]="itemSelect.comment"></textarea>
    <span class="count-characters" *ngIf="itemSelect">Caracteres restantes
      {{itemSelect?.comment?.length || 0}}/280</span>
  </app-modal>
  <app-modal class="modalComment" [show]="showModalAlternativeProposal"
             (onCallback)="modalAlternativeProposalCallback($event)">
    <h2 style="margin-bottom: 10px;">Comente sua proposta</h2>
    <textarea [maxlength]="200" rows="6" [(ngModel)]="alternativeProposal"></textarea>
    <span class="count-characters">Caracteres restantes {{alternativeProposal?.length || 0}}/200</span>
  </app-modal>
</app-template>
